import { StoreBadges } from '../../../components/StoreBadges/StoreBadges'
import { sectionAnchors } from '../../../config/routes'

// Hero — tagline, headline, download badges, primary CTA, and the
// phone-scanning-a-sheet visual with the CSS-only "graded ✓" reveal
// (ported from the prototype's .device/.graded-stamp markup + animation;
// prefers-reduced-motion is handled in brand.css, not here).
export const HeroSection = () => {
  return (
    <section className="hero">
      <div className="wrap hero-grid">
        <div>
          <span className="eyebrow">AI-Powered Answer Sheet Grading</span>
          <h1>
            Grade a stack of paper tests in <span className="accent">minutes</span>.
          </h1>
          <p className="sub">
            Snap a photo of an answer sheet — bubble (OMR) or handwritten — and let AI read, match, and score every
            answer. No scantron machines, no special paper.
          </p>
          <div className="cta-row" id="get">
            <a className="btn btn-primary" href={sectionAnchors.contact}>
              Get started
            </a>
            <a className="btn btn-ghost" href={sectionAnchors.howItWorks}>
              See how it works
            </a>
          </div>
          <StoreBadges />
        </div>

        <div className="device" aria-hidden="true">
          <div className="sheet">
            <h4>Answer Sheet · Maria S.</h4>
            <div className="q">
              <span className="bub on"></span>
              <span className="line"></span>
            </div>
            <div className="q">
              <span className="bub"></span>
              <span className="line"></span>
            </div>
            <div className="q">
              <span className="bub on"></span>
              <span className="line"></span>
            </div>
            <div className="q">
              <span className="bub"></span>
              <span className="line"></span>
            </div>
            <div className="q">
              <span className="bub on"></span>
              <span className="line"></span>
            </div>
          </div>
          <div className="phone">
            <div className="screen">
              <div className="app-top">
                <div className="t">Midterm — Math</div>
                <div className="s">28 students · graded</div>
              </div>
              <div className="app-body">
                <div className="result-card">
                  <div className="name">Maria Santos</div>
                  <div className="row">
                    <span className="score-pill">18 / 20</span>
                    <span className="badge-done">Completed</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="name">Liam Cruz</div>
                  <div className="row">
                    <span className="score-pill">15 / 20</span>
                    <span className="badge-flag">Needs review</span>
                  </div>
                </div>
                <div className="result-card">
                  <div className="name">Ana Reyes</div>
                  <div className="row">
                    <span className="score-pill">20 / 20</span>
                    <span className="badge-done">Completed</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="graded-stamp">
            <svg viewBox="0 0 24 24" fill="none">
              <path
                d="M4 12.5l5 5L20 6.5"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
    </section>
  )
}
